function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { throw: 1, return: 2, break: 3, continue: 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, catch: function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { isError } from 'lodash';
import { coreApi } from '../api/config';
var updateCaseState = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(referral, state) {
    var updatedCase;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return coreApi.updateRecord('case', referral.case_id, {
            state: state,
            primary_worker: state !== 'draft' ? referral.primary_case_worker_id : null
          });
        case 3:
          updatedCase = _context.sent;
          return _context.abrupt("return", updatedCase);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
          console.error('Error updateCaseState:', _context.t0);
          return _context.abrupt("return", false);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7]]);
  }));
  return function updateCaseState(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var updateCaseServiceType = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(referral) {
    var updatedCase;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return coreApi.updateRecord('case', referral.case_id, {
            service: referral.service_type_id,
            description: referral.description
          });
        case 3:
          updatedCase = _context2.sent;
          return _context2.abrupt("return", updatedCase);
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          console.error('Error updateCaseServiceType:', _context2.t0);
          return _context2.abrupt("return", false);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return function updateCaseServiceType(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var acceptReferral = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var referral,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          referral = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
          _context3.prev = 1;
          _context3.next = 4;
          return coreApi.updateRecord('referral', referral.id, {
            state: 'accepted'
          });
        case 4:
          return _context3.abrupt("return", _context3.sent);
        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](1);
          console.error('Error accepting referral:', _context3.t0);
          return _context3.abrupt("return", false);
        case 11:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 7]]);
  }));
  return function acceptReferral() {
    return _ref3.apply(this, arguments);
  };
}();
export var isHttpSuccess = function isHttpSuccess(response) {
  var codeNumber = response;
  if (_typeof(codeNumber) === 'object') {
    codeNumber = response.status;
  }
  return isError(response) || codeNumber > 199 && codeNumber < 300;
};
export var archiveReferral = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(referralId) {
    var response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return coreApi.updateRecord('referral', referralId, {
            flagged_for_sender: false
          });
        case 3:
          response = _context4.sent;
          if (!(!response || !isHttpSuccess(response.status))) {
            _context4.next = 6;
            break;
          }
          return _context4.abrupt("return", false);
        case 6:
          return _context4.abrupt("return", true);
        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](0);
          console.error('Error archiveReferral:', _context4.t0);
          return _context4.abrupt("return", false);
        case 13:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 9]]);
  }));
  return function archiveReferral(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
var isUnlistedProgram = function isUnlistedProgram(oonProvider) {
  return oonProvider.provider_type === "CUSTOM";
};
var createOONReferral = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var referral,
      oonProvider,
      unlistedProgramNote,
      newReferral,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          referral = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
          _context5.prev = 1;
          oonProvider = referral.out_of_network_providers[0];
          if (!isUnlistedProgram(oonProvider)) {
            _context5.next = 9;
            break;
          }
          unlistedProgramNote = {
            subjectType: 'case',
            subject: referral.case_id,
            employee: referral.primary_case_worker_id,
            visibility: "public",
            category: "external_provider",
            text: "Referred off platform to ".concat(oonProvider.custom_name)
          };
          _context5.next = 7;
          return coreApi.createRecord('note', unlistedProgramNote);
        case 7:
          _context5.next = 12;
          break;
        case 9:
          newReferral = _objectSpread({
            is_grouped: false,
            state: 'off_platform',
            case: referral.case_id,
            sending_provider: referral.referred_by_group_id,
            sending_network: referral.referred_by_network_id,
            receiving_network: referral.referred_by_network_id,
            receiving_provider: oonProvider.provider_id
          }, oonProvider.program_id ? {
            receiving_program: oonProvider.program_id
          } : null);
          _context5.next = 12;
          return coreApi.createRecord('referral', newReferral);
        case 12:
          if (!['recalled', 'declined'].includes(referral.state)) {
            _context5.next = 15;
            break;
          }
          _context5.next = 15;
          return archiveReferral(referral.id);
        case 15:
          return _context5.abrupt("return", true);
        case 18:
          _context5.prev = 18;
          _context5.t0 = _context5["catch"](1);
          console.error('Error creating Out Of Network case:', _context5.t0);
          return _context5.abrupt("return", false);
        case 22:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 18]]);
  }));
  return function createOONReferral() {
    return _ref5.apply(this, arguments);
  };
}();
var createReferral = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var referral,
      isGroupedReferrals,
      newReferral,
      createdReferral,
      _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          referral = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
          _context6.prev = 1;
          isGroupedReferrals = referral.referred_to_groups.length > 1;
          newReferral = _objectSpread(_objectSpread({
            state: 'sent',
            description: referral.description,
            case: referral.case_id,
            sending_provider: referral.referred_by_group_id,
            sending_network: referral.referred_by_network_id,
            receiving_network: referral.referred_to_network_id,
            receiving_provider: referral.referred_to_groups[0].group_id
          }, referral.referred_to_groups[0].program_id ? {
            receiving_program: referral.referred_to_groups[0].program_id
          } : {}), {}, {
            is_grouped: isGroupedReferrals
          });
          _context6.next = 6;
          return coreApi.createRecord('referral', newReferral);
        case 6:
          createdReferral = _context6.sent;
          if (!['recalled', 'declined'].includes(referral.state)) {
            _context6.next = 10;
            break;
          }
          _context6.next = 10;
          return archiveReferral(referral.id);
        case 10:
          return _context6.abrupt("return", createdReferral);
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](1);
          console.error('Error creating referral:', _context6.t0);
          return _context6.abrupt("return", false);
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[1, 13]]);
  }));
  return function createReferral() {
    return _ref6.apply(this, arguments);
  };
}();

// To forward a referral, first accept it, then update the case with the new service type, and finally create a new referral with the new provider.
var sendReferral = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref7) {
    var referral, _ref7$isOON, isOON, originalState, _yield$Promise$all, _yield$Promise$all2, acceptedReferral, updatedCase;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          referral = _ref7.referral, _ref7$isOON = _ref7.isOON, isOON = _ref7$isOON === void 0 ? false : _ref7$isOON, originalState = _ref7.originalState;
          _context7.prev = 1;
          if (!(originalState === 'sent' || originalState === 'in_review')) {
            _context7.next = 11;
            break;
          }
          _context7.next = 5;
          return Promise.all([acceptReferral(referral), updateCaseServiceType(referral)]);
        case 5:
          _yield$Promise$all = _context7.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          acceptedReferral = _yield$Promise$all2[0];
          updatedCase = _yield$Promise$all2[1];
          if (!(!acceptedReferral || !updatedCase)) {
            _context7.next = 11;
            break;
          }
          return _context7.abrupt("return", false);
        case 11:
          if (!isOON) {
            _context7.next = 14;
            break;
          }
          _context7.next = 14;
          return updateCaseState(referral, 'off_platform');
        case 14:
          if (isOON) {
            _context7.next = 20;
            break;
          }
          _context7.next = 17;
          return createReferral(referral);
        case 17:
          _context7.t0 = _context7.sent;
          _context7.next = 23;
          break;
        case 20:
          _context7.next = 22;
          return createOONReferral(referral);
        case 22:
          _context7.t0 = _context7.sent;
        case 23:
          return _context7.abrupt("return", _context7.t0);
        case 26:
          _context7.prev = 26;
          _context7.t1 = _context7["catch"](1);
          console.error("Error sending referral", _context7.t1);
          return _context7.abrupt("return", false);
        case 30:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[1, 26]]);
  }));
  return function sendReferral(_x5) {
    return _ref8.apply(this, arguments);
  };
}();
export default sendReferral;
//# sourceMappingURL=sendReferral.js.map